import { useParams, Link, Navigate } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { BLOG } from "@/data/catalog";

export default function BlogPost() {
  const { slug } = useParams();
  const post = BLOG.find((b) => b.slug === slug);
  if (!post) return <Navigate to="/blog" replace />;
  const more = BLOG.filter((b) => b.slug !== slug).slice(0, 3);

  return (
    <article data-testid="blog-post" className="pt-32 lg:pt-40">
      <div className="mx-auto max-w-3xl px-5 lg:px-10">
        <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-royal transition-colors" data-testid="back-to-blog"><ArrowLeft size={16} /> All articles</Link>
        <Reveal>
          <span className="mt-8 block overline text-royal">{post.cat} · {post.date} · {post.read}</span>
          <h1 className="mt-4 font-heading text-4xl lg:text-5xl font-extrabold text-foreground leading-[1.05]">{post.title}</h1>
        </Reveal>
      </div>
      <div className="mx-auto max-w-5xl px-5 lg:px-10 mt-10">
        <Reveal delay={0.1}><div className="overflow-hidden rounded-4xl border border-border"><img src={post.image} alt={post.title} className="w-full aspect-[16/8] object-cover" /></div></Reveal>
      </div>
      <div className="mx-auto max-w-3xl px-5 lg:px-10 mt-12">
        <p className="text-lg text-foreground leading-relaxed">{post.excerpt}</p>
        <p className="mt-6 text-muted-foreground leading-relaxed">{post.body}</p>
        <p className="mt-6 text-muted-foreground leading-relaxed">At ElitzPacks, our team helps translate these principles into real, cost-effective packaging that protects your products and grows your brand. Whether you&rsquo;re launching a new product or optimising an existing supply chain, the right packaging partner makes all the difference.</p>
        <div className="mt-10 rounded-3xl bg-navy text-white p-8 flex flex-col sm:flex-row sm:items-center justify-between gap-5">
          <p className="font-heading text-xl font-bold">Need packaging advice for your business?</p>
          <Link to="/request-quote" className="inline-flex items-center gap-2 rounded-full bg-white text-navy px-6 py-3 font-semibold hover:bg-emerald hover:text-white transition-colors w-fit">Get a Quote <ArrowRight size={16} /></Link>
        </div>
      </div>
      <div className="mx-auto max-w-[1400px] px-5 lg:px-10 py-20">
        <h2 className="font-heading text-2xl font-extrabold text-foreground mb-8">More articles</h2>
        <div className="grid sm:grid-cols-3 gap-6">
          {more.map((b) => (
            <Link key={b.slug} to={`/blog/${b.slug}`} className="group block rounded-3xl border border-border overflow-hidden">
              <div className="overflow-hidden aspect-[16/10]"><img src={b.image} alt={b.title} loading="lazy" className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" /></div>
              <div className="p-5"><h3 className="font-heading font-bold text-foreground group-hover:text-royal transition-colors">{b.title}</h3></div>
            </Link>
          ))}
        </div>
      </div>
    </article>
  );
}
